import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const USERS_STORE = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            email: 'email',
            firstName: 'firstName',
            lastName: 'lastName',
            phoneNumber: 'phoneNumber',
            profilePictureURL: 'profilePictureURL',
            isDisabled: 'isDisabled',
            currentStoreId: 'currentStoreId'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            email: 'e',
            firstName: 'fn',
            lastName: 'ln',
            phoneNumber: 'pn',
            profilePictureURL: 'ppu',
            isDisabled: 'isd',
            currentStoreId: 'csi'
        })
    })
})()
